import React from "react";
import { List, ListItem, Grid2 as Grid, Typography, Collapse, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CreditRequestLineItem from "./CreditRequestLineItem";
import PropTypes from "prop-types";
import CreditRequestListMenu from "./CreditRequestListMenu";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { creditStatus } from "../../util/creditRequestMapping";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
	},
	listItem: {
		padding: 0,
		paddingBottom: 10,
	},
	disabled: {
		backgroundColor: theme.palette.error.dark,
	},
	//Todo: get button style from app.js once merged with Josh's branch
	button: {
		textTransform: "none",
		color: theme.palette.text.primary,
		maxWidth: "40px",
		maxHeight: "35px",
		minWidth: "40px",
		minHeight: "35px",
		marginTop: "5px",
		marginBottom: "5px",
	},
	buttonIcon: {
		color: theme.palette.text.primary,
	},
}));

export default function CreditRequestList(props) {
	const { reason, status } = props;
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);
	const calculateTotalCost = () => {
		return props.lineItems.reduce((t, { lineCostInc }) => t + lineCostInc, 0).toFixed(2);
	};

	const showCancelMenuItem = () => {
		// to do when implementing cancel
		return false;
	};

	const showBeginReviewMenuItem = () => {
		return status === creditStatus.pendingReview || status === creditStatus.awaitingSupplier;
	};

	const showSubmitClaimMenuItem = () => {
		return status === creditStatus.reviewing;
	};

	const willShowCancelMenuItem = showCancelMenuItem();
	const willShowBeginReviewMenuItem = showBeginReviewMenuItem();
	const willShowSubmitClaimMenuItem = showSubmitClaimMenuItem();
	
	return (
		<>
			<Grid container size="grow">
				<Grid container size={7}>
					<Grid size="auto">
						<Button className={classes.button} onClick={() => setOpen(!open)}>
							{open ? (
								<ExpandLessIcon className={classes.buttonIcon} />
							) : (
								<ExpandMoreIcon className={classes.buttonIcon} />
							)}
						</Button>
					</Grid>
					<Grid size="grow">
						<Typography
							variant="caption"
							color="textSecondary"
							display="inline"
						>
							Reason
						</Typography>
						<Typography variant="body2" display="block">
							{reason}
						</Typography>
					</Grid>
				</Grid>
				<Grid size="grow" sx={{ pl: 2 }}>
					<Typography
						variant="caption"
						color="textSecondary"
						display="inline"
					>
						Total Cost Inc.
					</Typography>
					<Typography variant="body2" display="block">
						${calculateTotalCost()}
					</Typography>
				</Grid>
				<Grid container size="auto" justifyContent={"flex-end"}>
					{(willShowCancelMenuItem || willShowBeginReviewMenuItem || willShowSubmitClaimMenuItem) && (
						<CreditRequestListMenu
							onCancel={props.onCancel}
							onBeginReview={props.onBeginReview}
							onSubmitClaim={props.onSubmitClaim}
							reason={reason}
							showCancel={willShowCancelMenuItem}
							showBeginReview={willShowBeginReviewMenuItem}
							showSubmitClaim={willShowSubmitClaimMenuItem}
						/>
					)}
				</Grid>
				<Grid container size={12}>
					<Collapse in={open} timeout="auto" unmountOnExit className={classes.root}>
						<List className={classes.root}>
							{props.lineItems.map((li) => (
								<ListItem key={li.sku} className={classes.listItem}>
									<CreditRequestLineItem
										lineItem={li}
										reason={reason}
										saveChanges={props.saveChanges}
										cancelChanges={props.cancelChanges}
										reasons={props.reasons}
										updateLineItem={props.updateLineItem}
										creditRequestType={props.creditRequestType}
									/>
								</ListItem>
							))}
						</List>
					</Collapse>
				</Grid>
			</Grid>
		</>
	);
}
CreditRequestList.propTypes = {
	lineItems: PropTypes.array.isRequired,
	reason: PropTypes.string,
	reasons: PropTypes.array.isRequired,
	updateLineItem: PropTypes.func.isRequired,
	saveChanges: PropTypes.func.isRequired,
	cancelChanges: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	onBeginReview: PropTypes.func.isRequired,
	onSubmitClaim: PropTypes.func.isRequired,
	isAutoApprove: PropTypes.bool.isRequired,
	totalCostInc: PropTypes.number.isRequired,
	status: PropTypes.string,
	creditRequestType: PropTypes.string,
};
